$(function() {
  
  //cart final design confirmation dialog handlers
  
  /*
  //moved to this script from `Assets/theme.js.liquid`
  $('.checkout-button').on('click',function(){
    $('.cart-check-bg').animate({'top':'0','opacity':'0.5'},'slow');
    $('.cart-check').animate({'top':'50%','opacity':'1'},'slow');
  });
  //moved to this script from `Assets/cart.js`
  $('.close-modal img').on('click',function(){
    $('.cart-check, .cart-check-bg').fadeOut(500);
  });
  */
  
  $('.checkout-button').on('click', function() {
    $('.cart-check-bg').css({visibility: 'visible', display: ''}).animate({opacity: '0.4'}, 150);
    $('.cart-check').css({visibility: 'visible', display: ''}).animate({opacity: '1'}, 200);
  });
  
  $('.cart-check > .close-modal, .cart-check-back').on('click',function(e){
    e.stopPropagation();
    e.stopImmediatePropagation();
    $('.cart-check, .cart-check-bg').animate({opacity: '0'}, 200, function() {
      $(this).css({visibility: '', display: ''});
    });
  });
  
  $('.final-check-full-policy-btn').on('click', function() {
    $('.cart-check-full-terms').css({visibility: 'visible', display: ''}).animate({opacity: '1'}, 200);
  });
  
  $('.cart-check-full-terms > .close-modal, .cart-check-close-terms').on('click',function(e){
    e.stopPropagation();
    e.stopImmediatePropagation();
    $('.cart-check-full-terms').animate({opacity: '0'}, 200, function() {
      $(this).css({visibility: '', display: ''});
    });
  });
  
  //cart natural sort
  
  //rather than newest items on top, shows message card, and then gift wrap, underneath their respective parent items
  
  //store original indexes (for changing sort order in checkout)
  $('.cart-items tbody tr').each(function() {
    $(this).data('original-index', $(this).index());
  });
  
  //loop twice for easy way to ensure message cards always come before gift wrapping
  $('.cart-items tr[data-gift-option-parent][data-title="Gift Wrapping"]').each(function() {
    $(this).insertAfter('.cart-items tr[data-line-item-title="' + $(this).attr('data-gift-option-parent') + '"]');
  });
  $('.cart-items tr[data-gift-option-parent][data-title="Message Card"]').each(function() {
    $(this).insertAfter('.cart-items tr[data-line-item-title="' + $(this).attr('data-gift-option-parent') + '"]');
  });
  
  //save natural indexes into localstorage
  let cart_natural_sort_order = {};
  $('.cart-items tbody tr').each(function() {
    cart_natural_sort_order[$(this).data('original-index')] = $(this).index();
  });
  localStorage.setItem('cart_natural_sort_order', JSON.stringify(cart_natural_sort_order));
  
  //cleaner gift options
  
  //on clicking "add gifts" button in gift dialog, set a param for next page load not to scroll to the previous scroll position
  //without this, page scrolls back to below the cart (as the gift callout is below the cart) and user may miss their newly added items
  $('.gift-options').on('click', '.gift-options__action--add', function() {
    localStorage.setItem('cart_scroll_to_top_on_next_load', true);
  });
  
  let scroll_to_top_on_load = localStorage.getItem('cart_scroll_to_top_on_next_load');
  if (scroll_to_top_on_load) {
    localStorage.removeItem('cart_scroll_to_top_on_next_load');
    $(window).scrollTop(0);
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
      setTimeout(function() {
        if (history.scrollRestoration) {
          history.scrollRestoration = 'auto';
        }
      }, 2000);
    }
  } else {
    if (history.scrollRestoration) {
      history.scrollRestoration = 'auto';
    }
  }
  
  //inside a .5s timeout as gift popup content is generated by js in `gift-options.liquid` thus not immediately available on document.ready
  setTimeout(function() {
    $('.cart-items tr[data-line-item-title]').each(function(i) {
      let this_line_item_tr = $(this);

      //don't add gift options if this is a gift voucher
      if (this_line_item_tr.attr('data-line-item-title').includes('Voucher')) return; //in $.each, return = continue and return false = break

      //maybe add a new gift option product (if not first product, which is added automatically)
      if (this_line_item_tr.index() > 0) {
        $('.gift-options button[data-gift-option-action="create"]').trigger('click');
      }

      //populate values
      //another timeout because the button click() event doesnt create the new markup to populate instantly. needs a small delay.
      setTimeout(function() {
        let gift_option_block = $('.gift-options__modal .gift-options__options .gift-options__option:eq(' + i + ')');

        //select the relevant product, and trigger the select box
        let gift_item_select = gift_option_block.find('select.gift-options__option-line-items');
        let select_option = gift_item_select.find('option:last');
        gift_item_select.val(this_line_item_tr.attr('data-line-item-key'));

        //note: below, triggering change event with vanilla dispatchEvent does not work. using the giftOptions controller instead, per console.log(window), and `Assets/gift-options.js`
        //gift_item_select[0].dispatchEvent(new Event('change'));
        window.giftOptions.controller._onGiftOptionActions(gift_item_select[0]);

      }, 400);
    });
    
    //show "add gift options" buton on cart (hidden until after we've populated the dialog via our js)
    $('.gift-options__action--open ').addClass('show-gift-options-button');
  }, 800);
});